import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getSettingByName = (state, name) =>
  allModelsSelector(state, 'Setting', (setting) => setting.name === name)[0];
